import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import Head from 'View/brief-live/section/head';
import Tab from 'View/brief-live/section/tab';
import Filter from 'View/brief-live/section/filter';
import Table from 'View/brief-live/section/table';
import DetailWinnerModal from 'View/brief-live/section/detail-winner-list';
import PrizeListModal from 'View/brief-live/section/prize-list';

import BriefLiveProvider, { useBriefLiveState } from 'View/brief-live/state';

import styles from './styles.module.css';

const BriefLive = () => {
  const { state, updateState } = useBriefLiveState();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation('desktop-brief-live');

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab) updateState({ selectedTab: tab });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box className={styles['brief-live__container']}>
      <Head t={t} />
      <Tab t={t} />
      <Filter selectedTab={state?.selectedTab} t={t} />
      <Table t={t} />
      <DetailWinnerModal />
      <PrizeListModal />
    </Box>
  );
};

const BriefLiveContainer = () => <BriefLiveProvider children={<BriefLive />} />;

export default BriefLiveContainer;
